<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Subscription User-wise Details Report</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">
                Subscription User-wise Details Report
              </li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header">
            <div class="btn-toolbar pull-right">
              <a
                href="javascript:void(0)"
                class="btn btn-info"
                @click="show_filter = !show_filter"
                ><i class="fa fa-filter"></i>Filter</a
              >
            </div>

            <div class="card-tools">
              <button class="btn btn-info" @click="exportReport()">
                <i class="fas fa-download"></i> Export
              </button>
            </div>
          </div>
          <filters v-if="show_filter" :filter="filter" />
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <div class="card-body table-responsive-md p-0">
            <table class="table">
              <thead>
                <tr>
                  <th>User Payment Number</th>
                  <th>User Id</th>
                  <th>Username</th>
                  <th>Full Name</th>
                  <th>Mobile Number</th>
                  <th>Plan Name</th>
                  <th>First Subscription Date</th>
                  <th>Renewal Times</th>
                  <th>Last Payment Date</th>
                  <th>Unsubscription Date</th>
                  <th>Current status</th>
                  <th>Trx Id</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(report, index) in reports.data" :key="index">
                  <td>{{ report.user_payment_number }}</td>
                  <td>{{ report.user_id }}</td>
                  <td>{{ report.username }}</td>
                  <td>{{ report.name }}</td>
                  <td>{{ report.mobile_number }}</td>
                  <td>{{ report.plan_name }}</td>
                  <td>{{ report.first_subscription_date }}</td>
                  <td>{{ report.renewal_times }}</td>
                  <td>{{ report.last_payment_date }}</td>
                  <td>{{ report.unsubscription_date }}</td>
                  <td>{{ report.current_status }}</td>
                  <td>{{ report.trx_id }}</td>
                </tr>
              </tbody>
            </table>

            <div class="p-4" v-if="_.isEmpty(reports.data)">
              <div class="alert alert-default-warning" role="alert">
                No data found!
              </div>
            </div>
          </div>
          <div class="card-footer">
            <vue-pagination
              :pagination="reports"
              v-if="reports.total > reports.per_page"
              @paginate="init()"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import { LearningReportApi } from "@/services/api";
import SortIcons from "@/components/utils/SortIcons";
import Filters from "./components/UserDetailsFilter.vue";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import axios from "axios";
import fileDownload from "js-file-download";

export default {
  name: "SubscriptionUserwiseDetailsReport",
  metaInfo: {
    title: "Subscription User-wise Details Report | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons,
    Filters,
  },
  data: () => ({
    reports: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
    },
    show_filter: false,
    filter: {},
    is_loading: false,
  }),
  methods: {
    init() {
      this.filter = JSON.parse(JSON.stringify(this.$route.query));
      if (!_.isEmpty(this.filter)) this.show_filter = true;
      this.is_loading = true;
      let params = { ...this.filter, ...this.$route.query };
      LearningReportApi.subscriptionUserDetailReport(params)
        .then((response) => {
          this.reports = response;
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    resetFilter() {
      this.$router.push({ path: this.$route.path }).catch(() => {});
    },
    async getFilterData() {
      this.$router
        .push({
          path: this.$route.fullPath,
          query: this.filter,
        })
        .catch((err) => {
          console.log(err);
        });
    },
    exportReport: function () {
      this.is_loading = true;
      axios
        .get("/reports/subscriptions/user-details/export", {
          params: this.filter,
          responseType: "blob",
        })
        .then((response) => {
          fileDownload(response.data, "user-details-report.xlsx");
        })
        .catch((error) => {
          console.log("error " + error);
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
  },
  mounted() {
    this.init();
    this.$root.$on("sort-data", () => {
      this.$root.$emit("show-icon");
    });
  },
};
</script>
